import * as Cesium from 'cesium'
import emitter from '/@/event-bus'
import { GraphicalEntity } from './draw'
interface PointEntity extends Cesium.Entity {
  pointIndex?: number;
  typeInfo?: string;
  parent?: Cesium.Entity;
}
interface PolygonEntity extends Cesium.Entity {
  attrColor?: string;
  typeInfo?: string;
  latlngList?: { longitude: number; latitude: number; height: number }[];
  attr?: {
    horizontalDis?: number;
    horizontalArea?: number;
    heightDiff?: number;
  };
}
export class DrawFlightArea {
    private viewer: Cesium.Viewer;
    private store: any;
    private _dataSource: Cesium.CustomDataSource;
    private _custumDataSource: Cesium.CustomDataSource;
    private currentEntity: Cesium.Entity | null = null;
    private _currentMap: Map<string, Cesium.Entity> = new Map()
    private _currentCrawlerMap: Map<string, Cesium.Entity> = new Map()

    /** 绘制圆型区域参数 */
     private centerEntity: Cesium.Entity = null;
        private borderEntity: Cesium.Entity = null;
        private circleEntity: Cesium.Entity = null;
        private radiusText: Cesium.Entity = null;
        private material = {};
        private line: Cesium.Entity | null;
        private centerPos: { lng: any; lat: any; height: any; } | null
        private borderPos: { lng: number; lat: number; height: number; } | null
        private radius = 0.5
        private positions: any[] | undefined = []
        private editColor = '#19be6b'
        private circleColor = '#19be6b'
        private selectNodeType = ''
        private startTime = 0
        private createHandler
        private editHandler
        private isDrawing: boolean=false // 标记是否正在绘制
        private completedCircles: Cesium.Entity[] = [] // 保存已完成的圆
        private currentCircleId: number = 0 // 当前圆的ID

        /** 多边形 */
        private _tempPositions: Cesium.Cartesian3[] = []
        private polygonComObj: {
              positionList: Cesium.Cartesian3[];
              copyPositionList: Cesium.Cartesian3[];
              movePositions: Cesium.Cartesian3[];
              polygonEntity: PolygonEntity | null;
              pointTextEntity1: Cesium.Entity | null;
              pointTextEntity2: Cesium.Entity | null;
              pointEntityList: PointEntity[];
              textEntityList: Cesium.Entity[];
              editPointEntityList: PointEntity[];
              entityList: any[];
            } = {
              positionList: [],
              copyPositionList: [],
              movePositions: [],
              polygonEntity: null,
              pointTextEntity1: null,
              pointTextEntity2: null,
              pointEntityList: [],
              textEntityList: [],
              editPointEntityList: [],
              entityList: []
            };

        constructor (viewer: Cesium.Viewer, store: any = null) {
          this.viewer = viewer
          this.store = store
          this._dataSource = new Cesium.CustomDataSource('drawFlightAreaDataSource')
          this._custumDataSource = new Cesium.CustomDataSource('editFlightAreaDataSource')
          this.viewer.dataSources.add(this._dataSource)
          this.viewer.dataSources.add(this._custumDataSource)
          this.createHandler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas)
        }

private _createMoveEvent = (event: { endPosition: any; }) => {
  if (!this.centerEntity || !this.borderEntity || !this.circleEntity) {
    return
  }

  const pickResult = this._getPickObject(event.endPosition, this.viewer)
  const point = pickResult?.position
  if (!point) {
    return
  }

  const mouseCartesian = this.cartographic2latlngHeight(point)
  if (!mouseCartesian) {
    return
  }

  if (this.centerPos) {
    // 计算实时半径（圆心到鼠标点的距离）
    this.radius = this.twoPointsDistance(this.centerPos, mouseCartesian)
    this.radius = Math.max(this.radius, 0.5)

    // 使用新的方法计算边界点位置（沿着圆心到鼠标点的方向）
    const borderPoint = this.getCircleBorderCoordinate(this.centerPos, mouseCartesian, this.radius)
    const borderCartesian = Cesium.Cartesian3.fromDegrees(
      borderPoint.lng,
      borderPoint.lat,
      borderPoint.height
    )

    // 更新边界点实体位置
    if (this.borderEntity) {
      this.borderEntity.position = borderCartesian
      this.borderPos = borderPoint

      // 确保边界点可见
      if (this.borderEntity.point) {
        this.borderEntity.point.show = true
      }
    }

    // 更新半径文本
    // if (this.radiusText && this.centerPos && this.borderPos) {
    // const textPosition = this.getCenterTwoPoints(this.centerPos, this.borderPos)
    // this.radiusText.position = Cesium.Cartesian3.fromDegrees(
    //   textPosition.lng,
    //   textPosition.lat,
    //   textPosition.height
    // )
    // this.radiusText.label.text = `${this.radius.toFixed(2)}m`
    // this.radiusText.label.show = true
    // }

    // 更新圆形
    this.positions = this.calculateCirclePoints(this.centerPos, this.radius)
    this._updateCircleEntity()
  }
}

/**
 * 更新圆形实体显示
 */
private _updateCircleEntity () {
  if (!this.circleEntity || !this.positions) {
    return
  }

  // 由于使用了CallbackProperty，我们需要触发其重新计算
  // 可以通过临时修改positions引用来触发更新
  const tempPositions = [...this.positions]
  this.positions = tempPositions
}

startDrawCircle ():void {
  if (this.isDrawing) {
    console.warn('正在绘制中,请先完成当前绘制')
    return
  }
  this.isDrawing = true
  this.currentCircleId++
  this._registerEvents()
}

endDraw ():void {
  this._clearHandler()
  this._clearCreateEntity()
}

startDrawPolygon ():void {
  if (this.isDrawing) {
    console.warn('正在绘制中,请先完成当前绘制')
    return
  }
  this.isDrawing = true

  this.polygonComObj = {
    positionList: [],
    copyPositionList: [],
    movePositions: [],
    polygonEntity: null,
    pointTextEntity1: null,
    pointTextEntity2: null,
    pointEntityList: [], // 确保 pointEntityList 被初始化
    textEntityList: [],
    editPointEntityList: [],
    entityList: []
  }

  this._registerEventsPolygon()
}

_clearCreateEntity () {
  this._clearEntity()
  this.positions = []
}

private _registerEvents () {
  this._clearHandler()
  this._registerCreateEvents()
  // this._registerEditEvents()
}

private _registerEventsPolygon () {
  this._clearHandler()
  this._registerCreatePolygonEvents()
}

/**
   * 初始化多边形实体
   */
private initPolygonEntity (): void {
  const color = Cesium.Color.fromCssColorString(this.circleColor)
  color.alpha = 0.5

  this.polygonComObj.polygonEntity = this._dataSource.entities.add({
    polygon: {
      hierarchy: new Cesium.PolygonHierarchy([]),
      material: color,
      classificationType: Cesium.ClassificationType.BOTH
    },
    polyline: {
      positions: [],
      width: 6,
      material: new Cesium.PolylineDashMaterialProperty({
        color: Cesium.Color.fromCssColorString(this.circleColor),
        dashLength: 16
      }),
      clampToGround: true,
      classificationType: Cesium.ClassificationType.BOTH
    },
    show: true
  }) as PolygonEntity

  this.polygonComObj.polygonEntity.attrColor = this.circleColor
}

/**
     * 添加点
     * @param position 位置
     * @param pixelSize 像素大小
     * @param color 颜色
     * @param pointIndex 点索引
     * @param typeInfo 类型信息
     * @param parent 父实体
     */
private addPoint (
  position: Cesium.Cartesian3,
  pixelSize: number,
  color: Cesium.Color,
  pointIndex: number,
  typeInfo: string,
  parent: Cesium.Entity
): PointEntity {
  const entity = this._dataSource.entities.add({
    position: position,
    point: {
      pixelSize: pixelSize,
      color: color,
      disableDepthTestDistance: 3000000,
      show: true
    },
    billboard: {
      image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAYAQMAAADJbu9PAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAZQTFRFAAAAW/tlDx7VPwAAAAJ0Uk5TAP9bkSK1AAAAJElEQVR4nGNkrGdk3svIfpOR/yGj/E1G+72M9fWM/xlAgqQgALk7Exo5KkuiAAAAAElFTkSuQmCC',
      show: false,
      scale: 0.35,
      disableDepthTestDistance: 3000000
    }
  }) as PointEntity

  entity.pointIndex = pointIndex
  entity.typeInfo = typeInfo
  entity.parent = parent

  return entity
}

/**
   * 转化为真实点位经纬度
   * @param cartesian 笛卡尔坐标
   */
conversion (cartesian: Cesium.Cartesian3|Cesium.Cartesian3[]): any {
  if (cartesian instanceof Array) {
    return cartesian.map(item => this.conversion(item))
  } else {
    const ellipsoid = this.viewer.scene.globe.ellipsoid
    const cartographic = ellipsoid.cartesianToCartographic(cartesian)
    const pointInfo: any = {}
    pointInfo.longitude = Cesium.Math.toDegrees(cartographic.longitude) // 经度
    pointInfo.latitude = Cesium.Math.toDegrees(cartographic.latitude) // 纬度
    pointInfo.height = Number(cartographic.height.toFixed(1)) // 高度
    return pointInfo
  }
}

private _registerCreatePolygonEvents ():void {
  this.createHandler.setInputAction((event) => {
    const pickResult = this._getPickObject(event.position, this.viewer)
    const p = pickResult?.position
    if (!p) return

    // 检查是否点击了最后一个点来闭合多边形
    if (this.polygonComObj.pointEntityList &&
        this.polygonComObj.pointEntityList.length > 0 &&
        this.polygonComObj.positionList.length > 1) {
      const lastPoint = this.polygonComObj.pointEntityList[this.polygonComObj.pointEntityList.length - 1]
      const pickedObject = this.viewer.scene.pick(event.position)

      if (pickedObject && pickedObject.id === lastPoint) {
        const graphical = this._rightClickEventForPolygon()
        return
      }
    }

    this._tempPositions.push(p)
    if (!this.polygonComObj.polygonEntity) {
      this.initPolygonEntity()
    }

    this.polygonComObj.positionList.push(p)
    this.polygonComObj.copyPositionList.push(JSON.parse(JSON.stringify(p)))
    this.polygonComObj.movePositions = [...this.polygonComObj.positionList]

    const point = this.addPoint(p, 15, new Cesium.Color(1, 1, 1, 1),
      this.polygonComObj.positionList.length - 1, 'polygon_point',
      this.polygonComObj.polygonEntity!) as PointEntity

    // 确保 pointEntityList 已初始化
    if (!this.polygonComObj.pointEntityList) {
      this.polygonComObj.pointEntityList = []
    }

    this.polygonComObj.pointEntityList.push(point)

    if (this.polygonComObj.pointEntityList.length > 2) {
      const lastIndex = this.polygonComObj.pointEntityList.length - 1
      const secondLastIndex = lastIndex - 1

      if (this.polygonComObj.pointEntityList[lastIndex]) {
        this.polygonComObj.pointEntityList[lastIndex].point!.show = false
        this.polygonComObj.pointEntityList[lastIndex].billboard!.show = true
      }

      if (this.polygonComObj.pointEntityList[secondLastIndex]) {
        this.polygonComObj.pointEntityList[secondLastIndex].point!.show = true
        this.polygonComObj.pointEntityList[secondLastIndex].billboard!.show = false
      }
    }

    if (this.polygonComObj.polygonEntity) {
      this.polygonComObj.polygonEntity.polygon!.hierarchy = new Cesium.PolygonHierarchy([...this.polygonComObj.positionList])

      if (this.polygonComObj.positionList.length > 1) {
        this.polygonComObj.polygonEntity.polyline!.positions = [...this.polygonComObj.positionList, this.polygonComObj.positionList[0]]
      }
    }

    this.createHandler.setInputAction(this._mouseMoveEventForPolygon, Cesium.ScreenSpaceEventType.MOUSE_MOVE)
    this.createHandler.setInputAction(this._rightClickEventForPolygon, Cesium.ScreenSpaceEventType.RIGHT_CLICK)
  }, Cesium.ScreenSpaceEventType.LEFT_CLICK)
}

/**
   * 鼠标事件之绘制面的移动事件
   * @private
   */
private _mouseMoveEventForPolygon = (e) => {
  if (!this.isDrawing || this._tempPositions.length === 0) return

  const pickResult = this._getPickObject(e.endPosition, this.viewer)
  const position = pickResult?.position
  if (!position) {
    return
  }
  if (!position) return
  if (this.polygonComObj.positionList.length > 0 && position) {
                this.polygonComObj.polygonEntity!.polygon!.hierarchy = new Cesium.CallbackProperty(() => {
                  if (this.polygonComObj.movePositions.length === this.polygonComObj.positionList.length + 1) {
                    this.polygonComObj.movePositions.pop()
                  }
                  this.polygonComObj.movePositions.push(position)
                  return new Cesium.PolygonHierarchy(this.polygonComObj.movePositions)
                }, false)

                this.polygonComObj.polygonEntity!.polyline!.positions = new Cesium.CallbackProperty(() => {
                  if (this.polygonComObj.movePositions.length === this.polygonComObj.positionList.length + 1) {
                    this.polygonComObj.movePositions.pop()
                  }
                  this.polygonComObj.movePositions.push(position)
                  return [...this.polygonComObj.movePositions, this.polygonComObj.movePositions[0]]
                }, false)
  }
}

private _rightClickEventForPolygon = () => {
  // 安全检查：确保所有必要的属性都已初始化
  if (!this.polygonComObj ||
      !this.polygonComObj.positionList ||
      !this.polygonComObj.pointEntityList ||
      !this.polygonComObj.polygonEntity) {
    console.warn('多边形绘制对象未正确初始化')
    return null
  }

  if (this.polygonComObj.positionList.length > 2) {
    const color = this.polygonComObj.polygonEntity.attrColor || this.circleColor
    this.polygonComObj.polygonEntity.polyline!.positions = [...this.polygonComObj.positionList, this.polygonComObj.positionList[0]]
    this.polygonComObj.polygonEntity.polygon!.hierarchy = new Cesium.PolygonHierarchy([...this.polygonComObj.positionList])

    // 安全地显示/隐藏点实体
    const lastPointIndex = this.polygonComObj.pointEntityList.length - 1
    if (this.polygonComObj.pointEntityList[lastPointIndex]) {
      this.polygonComObj.pointEntityList[lastPointIndex].point!.show = true
      this.polygonComObj.pointEntityList[lastPointIndex].billboard!.show = false
    }

    const polygonColor = Cesium.Color.fromCssColorString(color)
    polygonColor.alpha = 0.5

    const polygonEntity = this._dataSource.entities.add({
      polygon: {
        hierarchy: new Cesium.PolygonHierarchy([]),
        material: polygonColor,
        classificationType: Cesium.ClassificationType.BOTH
      },
      polyline: {
        positions: [],
        width: 4,
        material: new Cesium.PolylineDashMaterialProperty({
          color: Cesium.Color.fromCssColorString(this.circleColor),
          dashLength: 16
        }),
        clampToGround: true,
        classificationType: Cesium.ClassificationType.BOTH
      },
      show: true
    }) as PolygonEntity

    polygonEntity.typeInfo = 'polygon'
    polygonEntity.attrColor = color

    // 转换为经纬度坐标
    const latlngList = this.conversion(this.polygonComObj.copyPositionList)
    polygonEntity.latlngList = latlngList

    // 计算距离和面积
    const horizontalDis = this.calcPolylineLength([...this.polygonComObj.positionList, this.polygonComObj.positionList[0]])
    const horizontalArea = this.calcPolygonArea(this.polygonComObj.positionList)
    const heightDiff = this.calcHeightDiff(this.polygonComObj.positionList)

    polygonEntity.attr = {
      horizontalDis: horizontalDis,
      horizontalArea: horizontalArea,
      heightDiff: heightDiff
    }

    const coordinates = latlngList.map(item => [item.longitude, item.latitude, item.height])

    // 添加到图形列表
    const graphical: GraphicalEntity = {
      type: 'polygon',
      positions: [...this.polygonComObj.positionList],
      coordinates: [coordinates], // 修正：使用 coordinates 而不是 center
      color: this.circleColor,
      createTime: new Date().toISOString(),
      entity: polygonEntity
    }

    this.completedCircles.push(graphical)
    this.currentEntity = graphical

    // 重置多边形绘制状态
    this.polygonComObj.positionList = []
    this.polygonComObj.copyPositionList = []
    this.polygonComObj.movePositions = []
    this.polygonComObj.entityList = []

    // 清理临时实体
    this.polygonComObj.textEntityList.forEach((textEntity, index) => {
      const position = textEntity.position!.getValue(Cesium.JulianDate.now())
      const editPoint = this.addPoint(
        position,
        8,
        new Cesium.Color(1, 1, 1, 0.7),
        index,
        'polygon_point_edit',
        this.polygonComObj.polygonEntity!
      ) as PointEntity

      if (!this.polygonComObj.editPointEntityList) {
        this.polygonComObj.editPointEntityList = []
      }

      this.polygonComObj.editPointEntityList.push(editPoint)
    })

    // 移除临时绘制的多边形实体
    if (this.polygonComObj.polygonEntity) {
      this._dataSource.entities.remove(this.polygonComObj.polygonEntity)
      this.polygonComObj.polygonEntity = null
    }

    // 移除临时点实体
    this.polygonComObj.pointEntityList.forEach(pointEntity => {
      this._dataSource.entities.remove(pointEntity)
    })
    this.polygonComObj.pointEntityList = []

    emitter.emit('flightAreasDroneLocation', graphical)
    this._resetDrawingState()
    this._registerEventsPolygon()

    return graphical
  }
  return null
}

/**
   * 计算高度差
   * @param positions 位置数组
   */
private calcHeightDiff (positions: Cesium.Cartesian3[]): number {
  if (positions.length === 0) return 0

  let minHeight = Number.MAX_VALUE
  let maxHeight = Number.MIN_VALUE

  positions.forEach(position => {
    const cartographic = Cesium.Cartographic.fromCartesian(position)
    if (cartographic.height < minHeight) minHeight = cartographic.height
    if (cartographic.height > maxHeight) maxHeight = cartographic.height
  })

  return maxHeight - minHeight
}

/**
   * 计算多边形面积
   * @param positions 位置数组
   */
private calcPolygonArea (positions: Cesium.Cartesian3[]): number {
  // 使用球面三角形面积公式计算多边形面积
  let area = 0
  const length = positions.length

  if (length < 3) return 0

  // 将笛卡尔坐标转换为经纬度坐标
  const cartographics = positions.map(pos => Cesium.Cartographic.fromCartesian(pos))

  // 使用球面三角形面积公式
  for (let i = 0; i < length; i++) {
    const j = (i + 1) % length
    const k = (i + 2) % length

    const lon1 = Cesium.Math.toDegrees(cartographics[i].longitude)
    const lat1 = Cesium.Math.toDegrees(cartographics[i].latitude)
    const lon2 = Cesium.Math.toDegrees(cartographics[j].longitude)
    const lat2 = Cesium.Math.toDegrees(cartographics[j].latitude)
    const lon3 = Cesium.Math.toDegrees(cartographics[k].longitude)
    const lat3 = Cesium.Math.toDegrees(cartographics[k].latitude)

    // 使用海伦公式计算三角形面积（简化版）
    const a = this.calcGreatCircleDistance(lat1, lon1, lat2, lon2)
    const b = this.calcGreatCircleDistance(lat2, lon2, lat3, lon3)
    const c = this.calcGreatCircleDistance(lat3, lon3, lat1, lon1)

    const s = (a + b + c) / 2
    const triangleArea = Math.sqrt(s * (s - a) * (s - b) * (s - c))

    area += triangleArea
  }

  return area
}

/**
   * 计算大圆距离
   * @param lat1 纬度1
   * @param lon1 经度1
   * @param lat2 纬度2
   * @param lon2 经度2
   */
private calcGreatCircleDistance (lat1: number, lon1: number, lat2: number, lon2: number): number {
  const R = 6371000 // 地球半径（米）
  const φ1 = lat1 * Math.PI / 180
  const φ2 = lat2 * Math.PI / 180
  const Δφ = (lat2 - lat1) * Math.PI / 180
  const Δλ = (lon2 - lon1) * Math.PI / 180

  const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
              Math.cos(φ1) * Math.cos(φ2) *
              Math.sin(Δλ / 2) * Math.sin(Δλ / 2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

  return R * c
}

/**
           * 计算线长度
           * @param positions 位置数组
           */
private calcPolylineLength (positions: Cesium.Cartesian3[]): number {
  let length = 0
  for (let i = 0; i < positions.length - 1; i++) {
    length += Cesium.Cartesian3.distance(positions[i], positions[i + 1])
  }
  return length
}

_registerCreateEvents () {
  this.createHandler.setInputAction((event: { position: any; }) => {
    const pickObject = this._getPickObject(event.position, this.viewer)
    const position = pickObject?.position

    if (!position) return

    const latLng = this.cartographic2latlngHeight(position)
    if (!latLng) return

    if (!this.centerPos) {
      // 第一次点击：设置中心点
      this._startNewCircle(latLng)
    } else {
      // 第二次点击：完成绘制
      this._completeCircleDrawing(latLng, pickObject)
    }
  }, Cesium.ScreenSpaceEventType.LEFT_CLICK)
}

setDrawColor (color: string) {
  this.circleColor = color
  this.material.circlePolygon = {
    material: Cesium.Color.fromCssColorString(color).withAlpha(0.4)
  }
  this.material.circlePolyline = {
    width: 4,
    material: new Cesium.PolylineDashMaterialProperty({
      color: Cesium.Color.fromCssColorString(color),
      dashLength: 16
    })
  }
  this.material.centerPoint = {
    size: 10,
    color: Cesium.Color.WHITE,
    show: true
  }
  this.material.boarderPoint = {
    size: 12, // 增大尺寸
    color: Cesium.Color.WHITE, // 使用黄色，更明显
    outlineColor: Cesium.Color.BLACK,
    outlineWidth: 2,
    show: true
  }
  this.material.line = {
    width: 4,
    material: new Cesium.PolylineDashMaterialProperty({
      color: Cesium.Color.fromCssColorString(color),
      dashLength: 20
    }),
    show: true
  }
}

/**
 * 开始绘制新圆
 */
private _startNewCircle (latLng: { lng: number; lat: number; height: number }) {
  this.radius = 0.5
  this.editColor = this.circleColor
  this.centerPos = latLng

  // 初始边界点与中心点相同
  this.borderPos = { ...latLng }

  // 创建编辑节点
  const nodePoint = this._createInitEditNodePoint(latLng)
  this.centerEntity = nodePoint.center
  this.borderEntity = nodePoint.boarderPoint

  // 确保边界点初始可见
  if (this.borderEntity.point) {
    this.borderEntity.point.show = true
  }

  // 创建圆形实体
  this.circleEntity = this._drawEditingCircle(this.centerPos, this.radius)
  // this.radiusText = this._addRadiusText()
  this.line = this._createLineBetweenCenterBoarder()

  // 确保线可见
  if (this.line.polyline) {
    this.line.polyline.show = true
  }

  // 注册鼠标移动事件
  this.createHandler.setInputAction(this._createMoveEvent, Cesium.ScreenSpaceEventType.MOUSE_MOVE)
}

_createLineBetweenCenterBoarder () {
  const entity = this._dataSource.entities.add({
    polyline: {
      positions: new Cesium.CallbackProperty(() => {
        if (this.centerPos && this.borderPos) {
          return [
            Cesium.Cartesian3.fromDegrees(this.centerPos.lng, this.centerPos.lat, this.centerPos.height),
            Cesium.Cartesian3.fromDegrees(this.borderPos.lng, this.borderPos.lat, this.borderPos.height)
          ]
        }
        return []
      }, false),
      width: this.material.line.width,
      material: this.material.line.material,
      clampToGround: true,
      classificationType: Cesium.ClassificationType.BOTH
    }
  })
  entity.typeInfo = 'line-between-center-boarder-edit'
  return entity
}

_createInitEditNodePoint (point: { lng: any; lat: any; height: any; }) {
  const entity = this._dataSource.entities.add({
    position: Cesium.Cartesian3.fromDegrees(point.lng, point.lat, point.height),
    point: {
      pixelSize: this.material.centerPoint.size,
      color: this.material.centerPoint.color,
      show: true,
      disableDepthTestDistance: 3e6,
      heightReference: Cesium.HeightReference.CLAMP_TO_GROUND
    }
  })
  entity.typeInfo = 'init-center-edit'

  // 修改边界点：使用point而不是billboard，确保显示出来
  const border = this._dataSource.entities.add({
    position: Cesium.Cartesian3.fromDegrees(point.lng, point.lat, point.height),
    point: {
      pixelSize: this.material.boarderPoint.size,
      color: this.material.boarderPoint.color,
      show: true,
      disableDepthTestDistance: 3e6,
      heightReference: Cesium.HeightReference.CLAMP_TO_GROUND
    }
  })
  border.typeInfo = 'init-border-point-edit'

  return {
    center: entity,
    boarderPoint: border
  }
}

_drawEditingCircle (point: any, radius: number) {
  this.positions = this.calculateCirclePoints(point, radius)
  const entity = this._dataSource.entities.add({
    polygon: {
      hierarchy: new Cesium.CallbackProperty(() => new Cesium.PolygonHierarchy(this.positions), false),
      material: this.material.circlePolygon.material,
      classificationType: Cesium.ClassificationType.BOTH
    },
    polyline: {
      positions: new Cesium.CallbackProperty(() => this.positions, false),
      width: this.material.circlePolyline.width,
      material: this.material.circlePolyline.material,
      clampToGround: true,
      classificationType: Cesium.ClassificationType.BOTH
    }
  })
  entity.typeInfo = 'editing-circle-entity'
  return entity
}

_addRadiusText () {
  const entity = this._dataSource.entities.add({
    label: {
      show: true,
      showBackground: true,
      font: '14px monospace',
      pixelOffset: new Cesium.Cartesian2(5, 5),
      disableDepthTestDistance: Number.POSITIVE_INFINITY
    }
  })
  entity.typeInfo = 'radius-text'
  return entity
}

/**
 * 完成圆形绘制
 */
private _completeCircleDrawing (latLng: { lng: number; lat: number; height: number }, pickObject: any) {
  const pickedObject = pickObject?.pickedObject

  // 点击边界点完成绘制
  if ((pickedObject?.id?.typeInfo === 'editing-circle-entity' || pickedObject?.id?.typeInfo === 'init-border-point-edit') && this.radius > 0) {
    this.radius = this.twoPointsDistance(this.centerPos, latLng)
    this.completeCurrentCircle()
    this._registerCreateEvents()
  }
}

/**
     * 完成当前圆的绘制并保存
     */
completeCurrentCircle () {
  if (!this.isDrawing || !this.centerPos) {
    return null
  }

  // 创建最终的圆实体（非编辑状态）
  const finalCircle = this._createFinalCircle(this.centerPos, this.radius)

  // 保存圆的信息
  const circleInfo = this.getCircleInfo(this.radius)
  finalCircle.circleInfo = {
    id: this.currentCircleId,
    radius: Number.parseFloat(this.radius.toFixed(2)),
    center: [this.centerPos.lng, this.centerPos.lat, this.centerPos.height],
    area: Number.parseFloat(circleInfo.area.toFixed(2)),
    perimeter: circleInfo.perimeter.toFixed(2),
    color: this.circleColor,
    createTime: new Date().toISOString(),
    entity: finalCircle
  }

  // 发射完成事件
  emitter.emit('flightAreasDroneLocation', finalCircle.circleInfo)
  //   emitter.emit('circleCompleted', {
  //     circle: finalCircle,
  //     info: finalCircle.circleInfo
  //   })

  // 重置绘制状态，准备下一次绘制
  this._resetDrawingState()

  return finalCircle
}

/**
     * 创建最终的圆（非编辑状态）
     */
private _createFinalCircle (point: any, radius: number): Cesium.Entity {
  const positions = this.calculateCirclePoints(point, radius)
  const entity = this._dataSource.entities.add({
    polygon: {
      hierarchy: new Cesium.PolygonHierarchy(positions),
      material: Cesium.Color.fromCssColorString(this.circleColor).withAlpha(0.4),
      classificationType: Cesium.ClassificationType.BOTH
    },
    polyline: {
      positions: positions,
      width: 4,
      material: new Cesium.PolylineDashMaterialProperty({
        color: Cesium.Color.fromCssColorString(this.circleColor),
        dashLength: 16
      }),
      clampToGround: true,
      classificationType: Cesium.ClassificationType.BOTH
    }
  })

  entity.typeInfo = 'final-circle'
  return entity
}

getCircleInfo (number: number) {
  const area = Number.parseFloat((Math.PI * number * number).toFixed(2))
  const perimeter = Number.parseFloat((2 * Math.PI * number).toFixed(2))
  return {
    area: area,
    perimeter: perimeter
  }
}

/**
     * 重置绘制状态
     */
private _resetDrawingState () {
  this._clearEntity()
  this._clearCreateHandler()

  this.centerPos = null
  this.borderPos = null
  this.radius = 0.5
  this.positions = []
  this.selectNodeType = ''
  this.isDrawing = true // 注意：这里应该是 false 吗？保持当前状态
  this.circleEntity = null

  // 完全重置 polygonComObj，确保所有属性都初始化
  this.polygonComObj = {
    positionList: [],
    copyPositionList: [],
    movePositions: [],
    polygonEntity: null,
    pointTextEntity1: null,
    pointTextEntity2: null,
    pointEntityList: [], // 确保 pointEntityList 被初始化
    textEntityList: [],
    editPointEntityList: [],
    entityList: []
  }
}

_clearEntity () {
  // 只清除编辑相关的临时实体，不删除已完成的圆
  const entitiesToRemove = [
    this.centerEntity,
    this.borderEntity,
    this.circleEntity,
    this.line,
    this.radiusText,
    this.polygonComObj.polygonEntity,
    ...this.polygonComObj.pointEntityList
  ].filter(entity => entity !== null) as Cesium.Entity[]

  entitiesToRemove.forEach(entity => {
    this._dataSource.entities.remove(entity)
  })

  this.centerEntity = null
  this.borderEntity = null
  // 只重置编辑中的圆实体，不重置已完成的圆
  if (this.circleEntity) {
    this.circleEntity = null
  }
  this.line = null
  this.radiusText = null
  this.polygonComObj = {}
}

_clearCreateHandler () {
  this.createHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK)
  this.createHandler.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE)
  this.createHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK)
  this.createHandler.removeInputAction(Cesium.ScreenSpaceEventType.RIGHT_CLICK)
}

getCircleBorderCoordinate (centerPoint: { lng: number; lat: number; }, mousePoint: { lng: number; lat: number; }, radius: number) {
  // 计算圆心到鼠标点的方向角度
  const dLng = mousePoint.lng - centerPoint.lng
  const dLat = mousePoint.lat - centerPoint.lat

  // 计算角度（弧度）
  const angle = Math.atan2(dLat, dLng)

  // 根据角度和半径计算边界点位置
  const borderLng = centerPoint.lng + (radius / (111320 * Math.cos(centerPoint.lat * Math.PI / 180))) * Math.cos(angle)
  const borderLat = centerPoint.lat + (radius / 111320) * Math.sin(angle)

  return {
    lng: borderLng,
    lat: borderLat,
    height: this.getTerrainHeight({ lng: borderLng, lat: borderLat }, this.viewer)
  }
}

/**
         * 获取指定经纬度的地形高度
         * @param {Object} position - 包含 lng, lat 的位置对象
         * @param {Object} viewer - Cesium 查看器实例
         * @returns {number} 地形高度（米），精度7位小数
         */
getTerrainHeight (position: { lng: any; lat: any; }, viewer: Cesium.Viewer) {
  const { lng, lat } = position

  // 创建地图坐标并获取高度
  const cartographic = Cesium.Cartographic.fromDegrees(lng, lat, 0)
  const terrainHeight = viewer.scene.globe.getHeight(cartographic)

  // 处理空值并格式化精度
  return Number.parseFloat((terrainHeight ?? 0).toFixed(7))
}

getCenterTwoPoints (position: { lng: any; lat: any; }, point: { lng: any; lat: any; }) {
  const lng = (position.lng + point.lng) / 2
  const lat = (position.lat + point.lat) / 2
  const p = this.getTerrainHeight({
    lng: lng,
    lat: lat
  }, this.viewer)
  return {
    lng: lng,
    lat: lat,
    height: p
  }
}

twoPointsDistance (firstPoint: { lng: number; lat: number; height?: number }, secondPoint: { lng: number; lat: number; height?: number }) {
  const left = Cesium.Cartesian3.fromDegrees(
    firstPoint.lng,
    firstPoint.lat,
    firstPoint.height || 0
  )
  const right = Cesium.Cartesian3.fromDegrees(
    secondPoint.lng,
    secondPoint.lat,
    secondPoint.height || 0
  )
  return Cesium.Cartesian3.distance(left, right)
}

cartographic2latlngHeight (position: Cesium.Cartesian3) {
  if (!position) return null
  const cartesian = Cesium.Cartographic.fromCartesian(position)
  const lng = Cesium.Math.toDegrees(cartesian.longitude).toFixed(7)
  const lat = Cesium.Math.toDegrees(cartesian.latitude).toFixed(7)
  const height = cartesian.height.toFixed(4)
  return {
    lng: Number.parseFloat(lng),
    lat: Number.parseFloat(lat),
    height: Number.parseFloat(height)
  }
}

_getPickObject (position: any, viewer: Cesium.Viewer) {
  let event, pick
  const ray = new Cesium.Ray()
  const scene = viewer.scene
  let i
  if (scene.mode !== Cesium.SceneMode.MORPHING) {
    if (scene.pickPositionSupported) {
      event = viewer.scene.pickPosition(position, i)
    }
    pick = scene.pick(position)
    if (Cesium.defined(pick)) {
      const pickRay = scene.camera.getPickRay(position, ray)
      pickRay && (event = scene.globe.pick(pickRay, scene, i))
    } else if (viewer.terrainProvider instanceof Cesium.EllipsoidTerrainProvider) { event = viewer.camera.pickEllipsoid(position, scene.globe.ellipsoid, i) } else {
      const pickRay = scene.camera.getPickRay(position, ray)
      pickRay && (event = scene.globe.pick(pickRay, scene, i))
    }
  }
  if (Cesium.defined(event) || Cesium.defined(pick)) {
    return {
      pickedObject: pick,
      position: event,
      screenPosition: position
    }
  }
}

calculateCirclePoints (point: { lng: number; lat: number; }, radius: number, steps = 64) {
  const positions: Cesium.Cartesian3[] = []
  const centerCartographic = Cesium.Cartographic.fromDegrees(point.lng, point.lat)

  for (let i = 0; i < steps; i++) {
    const angle = (i / steps) * 2 * Math.PI

    // 使用球面坐标计算圆上的点
    const lat = point.lat + (radius / 111320) * Math.cos(angle)
    const lng = point.lng + (radius / (111320 * Math.cos(point.lat * Math.PI / 180))) * Math.sin(angle)

    const height = this.getTerrainHeight({ lng, lat }, this.viewer)
    positions.push(Cesium.Cartesian3.fromDegrees(lng, lat, height))
  }

  // 闭合圆形
  if (positions.length > 0) {
    positions.push(positions[0].clone())
  }

  return positions
}

_clearHandler () {
  this._clearCreateHandler()
  // this._clearEditHandler()
}

clearEntity () {
  this._dataSource.entities.removeAll()
  this._custumDataSource.entities.removeAll()
  this.currentEntity = null
  this.borderEntity = null
  this.radius = 0.5
  this.radiusText = null
  this.centerPos = null
  this.selectNodeType = ''
  this.centerEntity = null
  this.borderPos = null
  this.positions = []
  this.editColor = '#19be6b'
  this.circleColor = '#19be6b'
  this.isDrawing = false
  this.completedCircles = []
  this._tempPositions = []
  this.polygonComObj = {
    positionList: [],
    copyPositionList: [],
    movePositions: [],
    polygonEntity: null,
    pointTextEntity1: null,
    pointTextEntity2: null,
    pointEntityList: [],
    textEntityList: [],
    editPointEntityList: [],
    entityList: [],

  }
  this._currentMap.clear()
  this.setDrawColor(this.circleColor)
}

clearDrawEntity () {
  this._dataSource.entities.removeAll()
  this.borderEntity = null
  this.radius = 0.5
  this.radiusText = null
  this.centerPos = null
  this.selectNodeType = ''
  this.centerEntity = null
  this.borderPos = null
  this.positions = []
  this.editColor = '#19be6b'
  this.circleColor = '#19be6b'
  this.isDrawing = false
  this.completedCircles = []
  this._tempPositions = []
  this.polygonComObj = {
    positionList: [],
    copyPositionList: [],
    movePositions: [],
    polygonEntity: null,
    pointTextEntity1: null,
    pointTextEntity2: null,
    pointEntityList: [],
    textEntityList: [],
    editPointEntityList: [],
    entityList: [],

  }
  this.setDrawColor(this.circleColor)
}

removeEntity (id: string) {
  this._custumDataSource.entities.removeById(id)
  this._currentMap.delete(id)
}

getEntity (id: string) {
  return this._currentMap.get(id)
}

setPolygonInfo (info: any, row: any) {
  const polygonInfo = this._currentMap.get(row.area_id)
  if (!polygonInfo) {
    const postions = []
    const position = {
      lat: '',
      lng: '',
      height: 200
    }

    // 计算多边形的中心点用于label定位
    let centerLng = 0
    let centerLat = 0
    let pointCount = 0

    info.geometry.coordinates[0].forEach((coordinate: any) => {
      const lng = coordinate[0] * 1
      const lat = coordinate[1] * 1
      position.lat = lat
      position.lng = lng
      postions.push(Cesium.Cartesian3.fromDegrees(lng, lat, 0))

      // 累加坐标计算中心点
      centerLng += lng
      centerLat += lat
      pointCount++
    })

    // 计算中心点
    centerLng /= pointCount
    centerLat /= pointCount
    const centerHeight = this.getTerrainHeight({ lng: centerLng, lat: centerLat }, this.viewer)
    const centerCartesian = Cesium.Cartesian3.fromDegrees(centerLng, centerLat, centerHeight + 50) // 稍微高于地面

    // postions.push(postions[0])

    let customColor = Cesium.Color.fromCssColorString(info.properties.color || '#fff')
    let color = Cesium.Color.fromCssColorString(info.properties.color || '#fff').withAlpha(0.5)
    if (row.type === 'nfz') {
      color = Cesium.Color.fromCssColorString('#FF0000').withAlpha(0.4)
      customColor = Cesium.Color.fromCssColorString('#FF0000')
    } else {
      color = Cesium.Color.fromCssColorString('#19be6b').withAlpha(0)
      customColor = Cesium.Color.fromCssColorString('#19be6b')
    }

    // 根据JSON数据中的clampToGround属性决定使用哪种配置
    const useClampToGround = info.properties.clampToGround !== false

    this.currentEntity = this._custumDataSource.entities.add({
      id: row.area_id,
      position: centerCartesian, // 添加位置属性，用于label定位
      polygon: {
        hierarchy: new Cesium.PolygonHierarchy(postions),
        material: color,
        classificationType: Cesium.ClassificationType.BOTH,
        ...(useClampToGround
          ? {
              clampToGround: true
            }
          : {
              heightReference: Cesium.HeightReference.RELATIVE_TO_GROUND,
              height: 0
            })
      },
      polyline: {
        positions: postions,
        width: 6,
        material: new Cesium.PolylineDashMaterialProperty({
          color: Cesium.Color.fromCssColorString(customColor.toCssColorString()),
          dashLength: 16.0
        }),
        clampToGround: true,
        classificationType: Cesium.ClassificationType.BOTH
      },
      label: {
        text: row.name,
        show: true,
        showBackground: false, // 改为true确保背景显示
        font: 'bold 14px "Microsoft YaHei", sans-serif',
        backgroundColor: Cesium.Color.BLACK.withAlpha(0.8),
        backgroundPadding: new Cesium.Cartesian2(8, 4),
        fillColor: Cesium.Color.WHITE,
        outlineColor: Cesium.Color.BLACK,
        outlineWidth: 2,
        style: Cesium.LabelStyle.FILL_AND_OUTLINE,
        pixelOffset: new Cesium.Cartesian2(0, 0),
        verticalOrigin: Cesium.VerticalOrigin.CENTER,
        horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
        heightReference: Cesium.HeightReference.RELATIVE_TO_GROUND,
        disableDepthTestDistance: Number.POSITIVE_INFINITY,
        scale: 1.0,
        translucencyByDistance: new Cesium.NearFarScalar(1.5e2, 1.0, 1.5e7, 0.5)
      },
      show: true
    })

    this.currentEntity.show = row.status && row.show
    this._currentMap.set(row.area_id, this.currentEntity)

    /* this.viewer.camera.setView({
      destination: Cesium.Cartesian3.fromDegrees(centerLng, centerLat, 200),
    }) */
  } else {
    this.currentEntity = polygonInfo
    this.currentEntity.show = row.status && row.show

    // 更新label显示状态
    if (this.currentEntity.label) {
      this.currentEntity.label.show = row.status
    }

    // this.viewer.flyTo(this.currentEntity)
  }
}

setApiList (list:any) {
  list.forEach((item, i) => {
    const rows = JSON.parse(item.subAreas)
    if (rows && rows.length > 0) {
      rows.forEach((row, index) => {
        if (row.shape === 1) {
          // console.log(item.name, i, row, index)
          if (rows.length > 1) {
            item.area_id = item.areaId + '_' + index
          }
        }

        this.setApiInfo(item, row)
      })
    }
  })
}

setApiListStatusChange (list, val) {
  list.forEach((item, i) => {
    const rows = JSON.parse(item.subAreas)
    if (rows && rows.length > 0) {
      rows.forEach((row, index) => {
        if (row.shape === 1) {
          if (rows.length > 1) {
            item.area_id = item.areaId + '_' + index
            const entity = this._currentMap.get(item.area_id)
            if (entity) {
              this.currentEntity = entity
              this.currentEntity.show = val
            } else {
              this.setApiInfo(item, row)
            }
          } else {
            const entity = this._currentMap.get(item.areaId)
            if (entity) {
              this.currentEntity = entity
              this.currentEntity.show = val
            } else {
              this.setApiInfo(item, row)
            }
          }
        }
      })
    }
  })
  this._custumDataSource.entities.values.forEach((item) => {
    if (item.typeinfo === 'customFlightArea') {
      item.show = val
    }
  })
}

setApiInfo (info, row) {
  const apiInfo = this._currentCrawlerMap.get(info.area_id || info.areaId)
  if (!apiInfo) {
    const centerPos = {
      lng: info.lng * 1,
      lat: info.lat * 1
    }
    const customColor = Cesium.Color.fromCssColorString(info.color || '#fff')
    const color = Cesium.Color.fromCssColorString(info.color || '#fff').withAlpha(0.5)
    // console.log('shape', row.shape)

    if (row.shape === 0 || row.shape === '0') {
      const radius = info.radius * 1
      const positions = this.calculateCirclePoints(centerPos, radius)
      // 根据JSON数据中的clampToGround属性决定使用哪种配置
      const useClampToGround = info.clampToGround !== false
      // 计算圆心位置（用于Label定位）
      const centerHeight = this.getTerrainHeight(centerPos, this.viewer)
      const centerCartesian = Cesium.Cartesian3.fromDegrees(
        centerPos.lng,
        centerPos.lat,
        centerHeight + 10 // 稍微高于地面，确保可见
      )
      this.currentEntity = this._custumDataSource.entities.add({
        id: info.areaId,
        position: centerCartesian, // 添加位置属性，用于Label定位
        polygon: {
          hierarchy: new Cesium.PolygonHierarchy(positions),
          material: color,
          classificationType: Cesium.ClassificationType.BOTH,
          ...(useClampToGround
            ? {
                clampToGround: true
              }
            : {
                heightReference: Cesium.HeightReference.RELATIVE_TO_GROUND,
                height: 0
              })
        },
        polyline: {
          positions: positions,
          width: 4,
          material: new Cesium.PolylineDashMaterialProperty({
            color: Cesium.Color.fromCssColorString(customColor.toCssColorString()),
            dashLength: 16.0 // 可以调整虚线间隔
          }),
          clampToGround: true,
          classificationType: Cesium.ClassificationType.BOTH
        },
        label: {
          text: info.name,
          show: false,
          showBackground: false,
          font: 'bold 14px "Microsoft YaHei", sans-serif', // 更明确的字体设置
          backgroundColor: new Cesium.Color(0, 0, 0, 0.8),
          backgroundPadding: new Cesium.Cartesian2(8, 4),
          fillColor: Cesium.Color.WHITE,
          outlineColor: Cesium.Color.BLACK,
          outlineWidth: 2,
          style: Cesium.LabelStyle.FILL_AND_OUTLINE,
          pixelOffset: new Cesium.Cartesian2(0, 0), // 调整为0，避免偏移过大
          verticalOrigin: Cesium.VerticalOrigin.CENTER,
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          heightReference: Cesium.HeightReference.RELATIVE_TO_GROUND,
          disableDepthTestDistance: Number.POSITIVE_INFINITY,
          scale: 1.0, // 明确设置缩放
          translucencyByDistance: new Cesium.NearFarScalar(1.5e2, 1.0, 1.5e7, 0.5) // 距离透明度控制
        }
      })
      this.currentEntity.typeinfo = 'customFlightArea'
      this.currentEntity.show = info.status
      this._currentCrawlerMap.set(info.areaId, this.currentEntity)
    } else {
      const postions = []
      const position = {
        lat: '',
        lng: '',
        height: 200
      }

      // 计算多边形的中心点用于label定位
      let centerLng = 0
      let centerLat = 0
      let pointCount = 0

      row.polygon_points[0].forEach((coordinate: any) => {
        const lng = coordinate[0] * 1
        const lat = coordinate[1] * 1
        position.lat = lat
        position.lng = lng
        postions.push(Cesium.Cartesian3.fromDegrees(lng, lat, 0))

        // 累加坐标计算中心点
        centerLng += lng
        centerLat += lat
        pointCount++
      })

      // 计算中心点
      centerLng /= pointCount
      centerLat /= pointCount
      const centerHeight = this.getTerrainHeight({ lng: centerLng, lat: centerLat }, this.viewer)
      const centerCartesian = Cesium.Cartesian3.fromDegrees(centerLng, centerLat, centerHeight + 50) // 稍微高于地面

      // postions.push(postions[0])

      // 根据JSON数据中的clampToGround属性决定使用哪种配置
      const useClampToGround = info.clampToGround !== false

      this.currentEntity = this._custumDataSource.entities.add({
        id: info.area_id,
        position: centerCartesian, // 添加位置属性，用于label定位
        polygon: {
          hierarchy: new Cesium.PolygonHierarchy(postions),
          material: color,
          classificationType: Cesium.ClassificationType.BOTH,
          ...(useClampToGround
            ? {
                clampToGround: true
              }
            : {
                heightReference: Cesium.HeightReference.RELATIVE_TO_GROUND,
                height: 0
              })
        },
        polyline: {
          positions: postions,
          width: 6,
          material: new Cesium.PolylineDashMaterialProperty({
            color: Cesium.Color.fromCssColorString(customColor.toCssColorString()),
            dashLength: 16.0
          }),
          clampToGround: true,
          classificationType: Cesium.ClassificationType.BOTH
        },
        label: {
          text: info.name,
          show: false,
          showBackground: false, // 改为true确保背景显示
          font: 'bold 14px "Microsoft YaHei", sans-serif',
          backgroundColor: Cesium.Color.BLACK.withAlpha(0.8),
          backgroundPadding: new Cesium.Cartesian2(8, 4),
          fillColor: Cesium.Color.WHITE,
          outlineColor: Cesium.Color.BLACK,
          outlineWidth: 2,
          style: Cesium.LabelStyle.FILL_AND_OUTLINE,
          pixelOffset: new Cesium.Cartesian2(0, 0),
          verticalOrigin: Cesium.VerticalOrigin.CENTER,
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          heightReference: Cesium.HeightReference.RELATIVE_TO_GROUND,
          disableDepthTestDistance: Number.POSITIVE_INFINITY,
          scale: 1.0,
          translucencyByDistance: new Cesium.NearFarScalar(1.5e2, 1.0, 1.5e7, 0.5)
        },
        show: true
      })

      this.currentEntity.show = info.status
      this.currentEntity.typeinfo = 'customFlightArea'
      this._currentCrawlerMap.set(info.area_id, this.currentEntity)
    }
  } else {
    this.currentEntity = apiInfo
    this.currentEntity.show = info.status
  }
}

/** 绘制已存在圆 */
setCircleList (list:any) {
  list.forEach((item: any) => {
    if (item.content.geometry.type === 'Circle') {
      this.setCircleInfo(item.content, item)
    } else {
      this.setPolygonInfo(item.content, item)
    }
  })
}

/** 自定义圆形区域 */
setCircleInfo (info: any, row: any) {
  const circleInfo = this._currentMap.get(row.area_id)
  if (!circleInfo) {
    const centerPos = {
      lng: info.geometry.coordinates[0] * 1,
      lat: info.geometry.coordinates[1] * 1
    }
    const radius = info.geometry.radius
    const positions = this.calculateCirclePoints(centerPos, radius)
    let customColor = Cesium.Color.fromCssColorString(info.properties.color || '#fff')
    let color = Cesium.Color.fromCssColorString(info.properties.color || '#fff').withAlpha(0.5)
    if (row.type === 'nfz') {
      color = Cesium.Color.fromCssColorString('#FF0000').withAlpha(0.4)
      customColor = Cesium.Color.fromCssColorString('#FF0000')
    } else {
      color = Cesium.Color.fromCssColorString('#19be6b').withAlpha(0)
      customColor = Cesium.Color.fromCssColorString('#19be6b')
    }
    // 根据JSON数据中的clampToGround属性决定使用哪种配置
    const useClampToGround = info.properties.clampToGround !== false

    // 计算圆心位置（用于Label定位）
    const centerHeight = this.getTerrainHeight(centerPos, this.viewer)
    const centerCartesian = Cesium.Cartesian3.fromDegrees(
      centerPos.lng,
      centerPos.lat,
      centerHeight + 10 // 稍微高于地面，确保可见
    )

    this.currentEntity = this._custumDataSource.entities.add({
      id: row.area_id,
      position: centerCartesian, // 添加位置属性，用于Label定位
      polygon: {
        hierarchy: new Cesium.PolygonHierarchy(positions),
        material: color,
        classificationType: Cesium.ClassificationType.BOTH,
        ...(useClampToGround
          ? {
              clampToGround: true
            }
          : {
              heightReference: Cesium.HeightReference.RELATIVE_TO_GROUND,
              height: 0
            })
      },
      polyline: {
        positions: positions,
        width: 4,
        material: new Cesium.PolylineDashMaterialProperty({
          color: Cesium.Color.fromCssColorString(customColor.toCssColorString()),
          dashLength: 16.0 // 可以调整虚线间隔

        }),
        clampToGround: true,
        classificationType: Cesium.ClassificationType.BOTH
      },
      label: {
        text: row.name,
        show: true,
        showBackground: false,
        font: 'bold 14px "Microsoft YaHei", sans-serif', // 更明确的字体设置
        backgroundColor: new Cesium.Color(0, 0, 0, 0.8),
        backgroundPadding: new Cesium.Cartesian2(8, 4),
        fillColor: Cesium.Color.WHITE,
        outlineColor: Cesium.Color.BLACK,
        outlineWidth: 2,
        style: Cesium.LabelStyle.FILL_AND_OUTLINE,
        pixelOffset: new Cesium.Cartesian2(0, 0), // 调整为0，避免偏移过大
        verticalOrigin: Cesium.VerticalOrigin.CENTER,
        horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
        heightReference: Cesium.HeightReference.RELATIVE_TO_GROUND,
        disableDepthTestDistance: Number.POSITIVE_INFINITY,
        scale: 1.0, // 明确设置缩放
        translucencyByDistance: new Cesium.NearFarScalar(1.5e2, 1.0, 1.5e7, 0.5) // 距离透明度控制
      }
    })

    this.currentEntity.show = row.status && row.show
    this._currentMap.set(row.area_id, this.currentEntity)

    // this.viewer.camera.setView({
    //   destination: Cesium.Cartesian3.fromDegrees(centerPos.lng, centerPos.lat, 200)
    // })
  } else {
    this.currentEntity = circleInfo
    this.currentEntity.show = row.status && row.show
    // this.viewer.flyTo(this.currentEntity)
  }
}
}

export default DrawFlightArea
